import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import Slider from '../../components/slider';
import './styles.css';

/**
 *  Presentation
 */
class Presentation extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    backgroundColor: PropTypes.string,
    bulletsBelow: PropTypes.bool,
    presentationItem: PropTypes.arrayOf(PropTypes.node),
    cta: PropTypes.arrayOf(PropTypes.node),
    photoInfo: PropTypes.arrayOf(PropTypes.node),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    pcDescription: null,
    mbDescription: null,
    backgroundColor: null,
    bulletsBelow: null,
    presentationItem: null,
    cta: null,
    photoInfo: null,
  };

  constructor(props) {
    super();
    this.props = props;
  }

  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      pcDescription,
      mbDescription,
      backgroundColor,
      bulletsBelow,
      presentationItem,
      cta,
      photoInfo,
    } = this.props;
    const settings = {
      autoplay: false,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      speed: 1500,
      ease: 'linear',
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      draggable: false,
      arrows: true,
      dots: true,
      adaptiveHeight: true,
      centerMode: false,
      centerPadding: 0,
      //mobileFirst: true,
      //prevArrow: '<button type="button" class="slick-prev" style="display: none;">Previous</button>',
      //nextArrow: '<div></div>',
      // prevArrow: '<button type="button" class="slick-prev" style="display: none;">Previous</button>',
      // nextArrow: '<button type="button" class="slick-next" style="display: none;">Next</button>',
      lazyLoad: 'progressive',
      //lazyLoad: 'ondemand',
      waitForAnimate: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            swipe: true,
            arrows: false,
            prevArrow: '<div></div>',
            nextArrow: '<div></div>',
          },
        },
      ],
      beforeChange: (old, current) => {
        let slickList = this.refs.slider.refs.slide.getElementsByClassName('slick-list')[0];
        slickList.classList.add('open');
        setTimeout(() => {
          slickList.classList.remove('open');
        }, 1000);
        this.refs.slider.beforeChange(old, current);
      },
    };

    //
    const getPcDescription = () => {
      if (pcDescription && pcDescription !== '') {
        return pcDescription;
      } else {
        return null;
      }
    };

    //
    const getMbDescription = () => {
      if (mbDescription && mbDescription !== '') {
        return mbDescription;
      } else {
        return getPcDescription();
      }
    };

    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className="Presentation"
             style={{backgroundColor: ((backgroundColor) ? backgroundColor: '#f5f5f5')}}
        >
          <div className="Presentation__container">
            <div className="Presentation__description">
              <div className="Presentation__description-pc Wysiwyg"
                   dangerouslySetInnerHTML={{__html: getPcDescription()}}
              />
              <div className="Presentation__description-mb Wysiwyg"
                   dangerouslySetInnerHTML={{__html: getMbDescription()}}
              />
            </div>
            {(bulletsBelow === false && presentationItem.length > 1) ?
              <div className="Presentation__pager"/>: null}
            <div className={'Presentation__carousel' + ((bulletsBelow === false) ? ' bulletsBelow': '')}>
              <Slider ref="slider"
                      settings={settings}
              >
                {presentationItem.map((child, index) => {
                  return (
                    <div className="Presentation__carousel-item"
                         key={index}
                    >
                      {child}
                    </div>
                  )
                })}
              </Slider>
            </div>
            {(bulletsBelow === true && presentationItem.length > 1) ?
              <div className="Presentation__pager"/>: null}
          </div>
          {(cta !== null && 1 <= cta.length) ? <div className="Presentation__cta">{cta}</div>: null}
          {(photoInfo !== null && 1 <= photoInfo.length) ? photoInfo: null}
        </div>
      </Wrapper>
    )

  }

}

export default Presentation;



// WEBPACK FOOTER //
// ./src/containers/presentation/index.jsx